import { FC } from "react";

export const SnowflakeIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13 2C13 1.44772 12.5523 1 12 1C11.4477 1 11 1.44772 11 2V5.58579L8.70711 3.29289C8.31658 2.90237 7.68342 2.90237 7.29289 3.29289C6.90237 3.68342 6.90237 4.31658 7.29289 4.70711L11 8.41421V11H8.41421L4.70711 7.29289C4.31658 6.90237 3.68342 6.90237 3.29289 7.29289C2.90237 7.68342 2.90237 8.31658 3.29289 8.70711L5.58579 11H2C1.44772 11 1 11.4477 1 12C1 12.5523 1.44772 13 2 13H5.58579L3.29289 15.2929C2.90237 15.6834 2.90237 16.3166 3.29289 16.7071C3.68342 17.0976 4.31658 17.0976 4.70711 16.7071L8.41421 13H11V15.5858L7.29289 19.2929C6.90237 19.6834 6.90237 20.3166 7.29289 20.7071C7.68342 21.0976 8.31658 21.0976 8.70711 20.7071L11 18.4142V22C11 22.5523 11.4477 23 12 23C12.5523 23 13 22.5523 13 22V18.4142L15.2929 20.7071C15.6834 21.0976 16.3166 21.0976 16.7071 20.7071C17.0976 20.3166 17.0976 19.6834 16.7071 19.2929L13 15.5858V13H15.5858L19.2929 16.7071C19.6834 17.0976 20.3166 17.0976 20.7071 16.7071C21.0976 16.3166 21.0976 15.6834 20.7071 15.2929L18.4142 13H22C22.5523 13 23 12.5523 23 12C23 11.4477 22.5523 11 22 11H18.4142L20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.29289C20.3166 6.90237 19.6834 6.90237 19.2929 7.29289L15.5858 11H13V8.41421L16.7071 4.70711C17.0976 4.31658 17.0976 3.68342 16.7071 3.29289C16.3166 2.90237 15.6834 2.90237 15.2929 3.29289L13 5.58579V2Z"
      fill="currentColor"
    />
  </svg>
);
